import { z } from 'zod';

/** The six noyaux, in the order of the PMS charter (also the display order). */
export const NOYAU_CODES = ['SGP', 'SPG', 'PSG', 'PGS', 'GPS', 'GSP'] as const;

export const noyauCodeSchema = z.enum(NOYAU_CODES);
export type NoyauCode = z.infer<typeof noyauCodeSchema>;

export const familleNoyauSchema = z.enum(['souverain', 'producteur', 'guerrier']);
export type FamilleNoyau = z.infer<typeof familleNoyauSchema>;

export const varianteNoyauSchema = z.enum([
  'magicien',
  'juriste',
  'réinventeur',
  'séducteur',
  'humain',
  'cosmique',
]);
export type VarianteNoyau = z.infer<typeof varianteNoyauSchema>;

/** Name of the colour token of the PMS design system (`--color-<token>` in styles.css). */
export const couleurNoyauSchema = z.enum([
  'bleu-nuit',
  'bleu-ciel',
  'vert',
  'jaune',
  'rouge',
  'rose',
]);
export type CouleurNoyau = z.infer<typeof couleurNoyauSchema>;

export const noyauSchema = z.object({
  code: noyauCodeSchema,
  famille: familleNoyauSchema,
  variante: varianteNoyauSchema,
  couleur: couleurNoyauSchema,
});
export type Noyau = z.infer<typeof noyauSchema>;

/** Reference data of the six noyaux, keyed by code. */
export const NOYAUX: Readonly<Record<NoyauCode, Noyau>> = {
  SGP: { code: 'SGP', famille: 'souverain', variante: 'magicien', couleur: 'bleu-nuit' },
  SPG: { code: 'SPG', famille: 'souverain', variante: 'juriste', couleur: 'bleu-ciel' },
  PSG: { code: 'PSG', famille: 'producteur', variante: 'réinventeur', couleur: 'vert' },
  PGS: { code: 'PGS', famille: 'producteur', variante: 'séducteur', couleur: 'jaune' },
  GPS: { code: 'GPS', famille: 'guerrier', variante: 'humain', couleur: 'rouge' },
  GSP: { code: 'GSP', famille: 'guerrier', variante: 'cosmique', couleur: 'rose' },
};
